import { useMoralis, useMoralisQuery } from "react-moralis";
import { Button } from "antd";

import { ethers } from "ethers";
import NFTComponentPass from "./NFTComponentPass";

function NFTPasses(props) {
  const { Moralis } = useMoralis();

  const queryMarketItems = useMoralisQuery("NftCreated");
  const fetchMarketItems = JSON.parse(
    JSON.stringify(queryMarketItems.data, [
      "objectId",
      "createdAt",
      "copies",
      "remainingCopies",
      "price",
      "metadata",
      "nftOwner",
      "nftId",
      "signature",
      "nonce",
      "name",
      "image",
      "description",
    ])
  ).filter((item) => item.nftId < 3);

  const getMarketItem = () => {
    const result = fetchMarketItems?.find((e) => e.copies > 0);
    return result;
  };
  async function Sign() {
    const createdItems = getMarketItem();
    console.log("getMarketItem", createdItems);
    const SIGNING_DOMAIN_NAME = "Voucher-Domain";
    const SIGNING_DOMAIN_VERSION = "1";
    const chainId = 80001;
    const contractAddress = "0x8844Cf49E0f19758d17DC8fE96cb8F0B88fC73d1"; // Put the address here from remix
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    // Prompt user for account connections
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    const domain = {
      name: SIGNING_DOMAIN_NAME,
      version: SIGNING_DOMAIN_VERSION,
      verifyingContract: contractAddress,
      chainId,
    };
    const tokenId = createdItems.nftId;
    const minPrice = createdItems.price;
    const copies = createdItems.copies;
    const artist = createdItems.nftOwner;
    const voucher = { tokenId, minPrice, copies, artist };
    const types = {
      NFTVoucher: [
        { name: "tokenId", type: "uint256" },
        { name: "minPrice", type: "uint256" },
        { name: "copies", type: "uint256" },
        { name: "artist", type: "address" },
      ],
    };
    const signature = await signer._signTypedData(domain, types, voucher);
    console.log("sign", signature);
    const queryMarketItems = Moralis.Object.extend("NftCreated");
    const query = new Moralis.Query(queryMarketItems);
    const setQuery = await query.first();
    setQuery.set("signature", signature);
    setQuery.save();
  }

  return (
    <>
      <div className="mt-2 s-p">
        <div className="text-center">
          <Button
            className="primary-button buy-button text-white mt-5"
            onClick={() => Sign()}
            size="large"
          >
            Sign NFT
          </Button>
        </div>
        {fetchMarketItems?.map((item, index) => (
          <NFTComponentPass item={item} />
        ))}
      </div>
    </>
  );
}

export default NFTPasses;
